<template lang="pug">
section
  
  .top
     MouserGeneralHeader

  .configuration(v-if="loaded")
  
  .content
    
    .main
      h1.configuration-title {{ products.name }}
      MouserProductSheet(:title="products.name", :configID="configID", :products="products")
      .section.bill-of-materials
        h2.section-title Bill of Materials
        .products
          MouserProductTile(:product="products.connectors[0]", :showPDF="true", :createLink="false")
          MouserProductTile(:product="products.cable", :showPDF="true", :createLink="false")
          MouserProductTile(:product="products.connectors[1]", :showPDF="true", :createLink="false")
      .section(v-if="related.length")
        h2.section-title Mating Connectors
        .products
          MouserProductTile(
            v-for="product in related",
            :key="product.sku",
            :product="product", 
            :showPDF="false",
            :createLink="false")
    .rail
      MouserCart(
        :title="products.name",
        :configID="configID",
        :price="products.price",
        :emailTopic="products.configuration.emailTopic",
        :emailBody="products.configuration.emailBody")
</template>

<script>
// @ is an alias to /src
import MouserGeneralHeader from "@/components/configurator/MouserGeneralHeader";
import MouserProductSheet from "@/components/configuration/MouserProductSheet.vue";
import MouserCart from "@/components/configuration/MouserCart.vue";
import MouserProductTile from "@/components/configuration/MouserProductTile.vue";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "MouserConfiguration",
  components: {
    MouserGeneralHeader,
    MouserProductSheet,
    MouserCart,
    MouserProductTile,
  },
  data() {
      return {
      loaded: false,
      configID: null,
      products: null
    };
  },
  computed: {
    ...mapGetters(["configLookup", "relatedLength"]),
      related() {
      const connectors = [this.products.connectors[0], this.products.connectors[1]];
      const related = connectors.reduce((related, product) => {
        const { matingConnectors} = product;
          if (matingConnectors) {
          matingConnectors.forEach((matingConnector) => {
            if(!related.includes(matingConnector)){
              related.push(matingConnector);
            }
          });
        }
        return related;
      }, []);

          return related;
    },
  },

   methods: {
    ...mapMutations(["setConfiguration", "setErrorMessage"]),
  },
  async created() {
      const configID = this.$route.params.product;
      const length = this.$route.query.length;
      const delay = this.$route.query.delay;    
    if (!configID) return this.$router.replace({ path: "/" });

      const response = await fetch(`${this.$root.detailsApi}/${configID}?length=${length}&delay=${delay}`);      
      if (response.ok) {
          const productDetails = await response.json();
          if (productDetails["errorMessage"]) {
              this.setErrorMessage(productDetails["errorMessage"]);
              return this.$router.replace({ path: "/" });
          }
          this.products = productDetails;
          this.configID = productDetails['configID'];
          const value = productDetails['configuration'];
          
          this.setConfiguration(value);
          this.loaded = true;

      }
      else {
          return this.$router.replace({ path: "/" });
      }
  },
};
</script>


<style lang="scss" scoped>

.top {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: $white;
  box-shadow: 0 0 0.5rem rgba($black, 0.0375), 0 0 1rem rgba($black, 0.02);
}

.content {
  margin-top: 1em;
  display: flex;
  position: relative;
  gap: 1.5rem;
  @include mq(lg) {
    flex-direction: row;
    align-items: flex-start;
  }
}

.main,
.rail {
  display: flex;
  flex-direction: column;
  background: $white;
  box-shadow: 0 0 0.5rem rgba($black, 0.0375), 0 0 1rem rgba($black, 0.02);
  @media print {
    background: transparent;
    box-shadow: none;
  }
}

.main {
  padding: clamp(1.125rem, 3vw, 2rem);

  @include mq(lg) {
    flex: 1 1 100%;
  }
}
.rail {
  order: -1;
  @include mq(lg) {
    order: 1;
    position: sticky;
    top: 1.5rem;
    flex: 0 0 22rem;
  }
}

.configuration-title {
  font-weight: 400;
  font-size: 1.125rem;
  margin: 0 0 1.5rem;
}

.section {
  margin-top: 2.5rem;
}

.section-title {
  font-weight: 400;
    font-size: 1.5rem;
  margin: 0 0 1.5rem;

}

.products {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-auto-rows: 1fr;
  gap: 1rem;
}
</style>